module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result26-6f5e2065339937d13ea69adb51555ca5.png";